import { normalizePermissions } from '../config/permissionModules';

export const normalizeAdminSession = (response) => {
  if (!response || typeof response !== 'object') return null;

  const user = response.user ?? response.data?.user ?? response.admin ?? response.data ?? response;
  const token = response.token ?? response.data?.token ?? user?.token;
  const role = user?.role ?? response.role;
  const permissions = user?.permissions ?? response.permissions;

  return {
    token,
    user: {
      ...user,
      role,
      permissions
    }
  };
};

export const getLoggedInAdmin = () => {
  try {
    const raw = localStorage.getItem('adminData');
    if (!raw) return null;

    const data = JSON.parse(raw);
    const session = data.user ? data : normalizeAdminSession(data);
    return session?.user ?? null;
  } catch {
    return null;
  }
};

export const updateAdminSession = (userPatch) => {
  try {
    const raw = localStorage.getItem('adminData');
    if (!raw) return;

    const data = JSON.parse(raw);
    const session = data.user ? data : normalizeAdminSession(data);
    if (!session?.user) return;

    const nextUser = { ...session.user, ...userPatch };
    localStorage.setItem('adminData', JSON.stringify({ ...session, user: nextUser }));
    window.dispatchEvent(new Event('adminSessionUpdated'));
  } catch {
    // ignore storage errors
  }
};

export const isAdminRole = (role) => {
  if (!role) return false;
  const normalized = role.toString().trim().toLowerCase();
  return (
    normalized === 'admin' ||
    normalized === 'superadmin' ||
    normalized === 'super admin' ||
    normalized === 'administrator'
  );
};

export const hasFullAccess = (admin = getLoggedInAdmin()) => {
  if (!admin) return false;
  return isAdminRole(admin.role);
};

export const hasModulePermission = (permissions, module, type = 'read') => {
  const normalized = normalizePermissions(permissions);
  const val = normalized[module];
  if (!val) return false;
  return Boolean(val[type]);
};

export const canAccessMenuItem = (permissionKey, admin = getLoggedInAdmin()) => {
  if (!permissionKey) return true;
  if (hasFullAccess(admin)) return true;

  const permissions = admin?.permissions;
  return (
    hasModulePermission(permissions, permissionKey, 'read') ||
    hasModulePermission(permissions, permissionKey, 'write')
  );
};

export const filterMenuChildren = (children = [], admin = getLoggedInAdmin()) => {
  if (hasFullAccess(admin)) {
    return children.filter((item) => item.id !== 'login');
  }

  return children
    .map((item) => {
      if (item.id === 'login') return null;

      if (item.type === 'collapse' && item.children) {
        const filteredChildren = filterMenuChildren(item.children, admin);
        if (!filteredChildren.length) return null;
        return { ...item, children: filteredChildren };
      }

      if (item.adminOnly && !hasFullAccess(admin)) {
        return null;
      }

      if (item.permissionKey && !canAccessMenuItem(item.permissionKey, admin)) {
        return null;
      }

      return item;
    })
    .filter(Boolean);
};
